/**
 * Set all the cards from a same Columns block with the max card height found.
 */
export default function cardsHeight() {
  const cardsGrid = Array.from( document.querySelectorAll( '.wp-block-columns' ) )

  cardsGrid.forEach( cardGrid => init( cardGrid ) )

  /**
   * Set for all grids found.
   *
   * @param {node} cardGrid The card grid parent container.
   */
  function init( cardGrid ) {
    let cardMaxHeight = 0

    const cards = Array.from( cardGrid.querySelectorAll( '.block-card > div, .block-card > a' ) )

    /**
     * Find the max card height.
     */
    cards.forEach( card => {
      if ( card && card.offsetHeight > cardMaxHeight ) {
        cardMaxHeight = card.offsetHeight
      }

      const cardReadmore = card.querySelector( '.person-bio__btn__read-more' )

      if ( cardReadmore ) {
        cardReadmore.style.position = 'absolute'
        cardReadmore.style.bottom = '2rem'
      }
    })

    /**
     * Set all cards from the grid with the max height found.
     */
    cards.forEach( card => {
      if ( card ) {
        card.style.height = `${cardMaxHeight}px`
      }
    })
  }
}
